export class BetModel {

    id: string;

    constructor(source: BetModel) {
        this.id = source.id;
    }
}